/**
 * Relationship options for policy beneficiaries. Values are the backend `PrimaryInsuredRelation` names.
 * Sisme only has Cónyuge, Hijo, Madre and Padre; the rest are sent to the core as "Opcional",
 * which is never offered here.
 */
export const BENEFICIARY_RELATIONSHIPS: ReadonlyArray<{ value: string; label: string }> = [
  { value: 'Conyuge', label: 'Cónyuge' },
  { value: 'Child', label: 'Hijo/Hija' },
  { value: 'Madre', label: 'Madre' },
  { value: 'Padre', label: 'Padre' },
  { value: 'Hermano', label: 'Hermano/Hermana' },
  { value: 'Abuelo', label: 'Abuelo/Abuela' },
  { value: 'Nieto', label: 'Nieto/Nieta' },
  { value: 'Primo', label: 'Primo/Prima' },
  { value: 'Tio', label: 'Tío/Tía' },
  { value: 'Sobrino', label: 'Sobrino/Sobrina' },
];

export function beneficiaryRelationshipLabel(value?: string | null): string {
  if (!value) return '';
  const match = BENEFICIARY_RELATIONSHIPS.find((r) => r.value.toLowerCase() === value.toLowerCase());
  return match?.label ?? value;
}
